<template>
  <div>
    <v-alert
      color="primary"
      border="top"
      colored-border
      type="info"
      elevation="2"
    >
      <div style="padding-left: 16px">
        <TextBody>
          {{ t$(".text") }}
        </TextBody>
        <TextBody>
          {{ t$(".question") }}
          <Hyperlink
            :click-handler="navigateToPostForm"
            :text="t$('.link')"
          ></Hyperlink>
        </TextBody>
      </div>
    </v-alert>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import TextBody from "components/UI/TextBody.vue"
import Hyperlink from "components/UI/Hyperlink.vue"
import TextButton from "components/UI/TextButton.vue"
import useTranslate from "features/common/translate/concerns/useTranslate"

export default defineComponent({
  name: "EventHighlightsEmptyContent",
  components: { TextButton, Hyperlink, TextBody },
  setup() {
    const navigateToPostForm = () => {
      const postForm = document.getElementById("suus__post-form")
      postForm?.scrollIntoView({ behavior: "smooth" })
    }

    const { t$ } = useTranslate("components.event_highlights_tab.empty_content")

    return {
      navigateToPostForm,
      t$,
    }
  },
})
</script>
